import { cn } from '@/lib/utils';

interface StatusBadgeProps {
  status: 'pending' | 'complete' | 'failed';
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const styles = {
    pending: 'status-pending animate-pulse-glow',
    complete: 'status-complete',
    failed: 'status-failed',
  };

  const labels = {
    pending: 'Analyzing...',
    complete: 'Complete',
    failed: 'Failed',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium',
        styles[status],
        className
      )}
    >
      {labels[status]}
    </span>
  );
}
